import { createRouter, createWebHashHistory } from 'vue-router';
import p404 from '@/views/static/p404.vue';
import privacyPage from '@/views/authorized/help/agreement/privacyPage.vue';
import permissionPage from '@/views/authorized/help/agreement/permissionPage.vue';
import StandardPage from '@/views/authorized/help/agreement/standardPage.vue';
import supportPage from '@/views/authorized/help/supportPage.vue';
import maintenancePage from '@/views/authorized/help/maintenancePage.vue';
import announcementPage from '@/views/authorized/help/announcementPage.vue';
import repaymentPage from '@/views/authorized/help/repaymentPage.vue';
import resultPage from '@/views/authorized/resultPage.vue';
import orderTerms from '@/views/authorized/help/agreement/orderTerms.vue';
import messagePage from '@/views/authorized/messagePage.vue';

const routes = [
  {
    path: '/',
    name: 'default',
    component: privacyPage,
    meta: {
      authorized: true
    }
  },
  {
    path: '/privacy',
    name: 'privacyPage',
    component: privacyPage,
    props: {
      type: 'general'
    },
    meta: {
      authorized: true
    }
  },
  {
    path: '/privacy_policy/ios',
    name: 'privacyPageIOS',
    component: privacyPage,
    props: {
      type: 'ios'
    },
    meta: {
      authorized: true
    }
  },
  {
    path: '/permission',
    name: 'permissionPage',
    component: permissionPage,
    props: {
      type: 'general'
    },
    meta: {
      authorized: true
    }
  },
  {
    path: '/permission/ios',
    name: 'permissionPageIOS',
    component: permissionPage,
    props: {
      type: 'ios'
    },
    meta: {
      authorized: true
    }
  },
  {
    path: '/standard',
    name: 'StandardPage',
    component: StandardPage,
    meta: {
      authorized: true
    }
  },
  {
    path: '/support',
    name: 'supportPage',
    component: supportPage,
    meta: {
      authorized: true
    }
  },
  {
    path: '/maintenance',
    name: 'maintenancePage',
    component: maintenancePage,
    meta: {
      authorized: true
    }
  },
  {
    path: '/announcement',
    name: 'announcementPage',
    component: announcementPage,
    meta: {
      authorized: true
    }
  },


  {
    path: '/orderTerms',
    name: 'orderTermsPage',
    component: orderTerms,
    meta: {
      authorized: true
    }
  },

  {
    path: '/message',
    name: 'messagePage',
    component: messagePage,
    meta: {
      authorized: true
    }
  },
  {
    path: '/result',
    name: 'resultPage',
    component: resultPage,
    meta: {
      authorized: true
    }
  },
  {
    path: '/repayment',
    name: 'repaymentPage',
    component: repaymentPage,
    meta: {
      authorized: true
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: p404,
    meta: {
      authorized: false
    }
  },
  /*
  {
    path: '/aboutApp',
    name: 'aboutApp',
    component: aboutUsPage,
    meta: {
      authorized: true
    }
  },
  */
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  next();
});

export default router;
